import React, { useEffect, useState } from "react";
import "./feedbackModal.scss";
import Image from "next/image";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useSelector } from "react-redux";

import initial1 from "@/../public/modals/feedbackModal/initial-imgs/1.png";
import initial2 from "@/../public/modals/feedbackModal/initial-imgs/2.png";
import initial3 from "@/../public/modals/feedbackModal/initial-imgs/3.png";
import initial4 from "@/../public/modals/feedbackModal/initial-imgs/4.png";
import initial5 from "@/../public/modals/feedbackModal/initial-imgs/5.png";
import final1 from "@/../public/modals/feedbackModal/final-imgs/1.png";
import final2 from "@/../public/modals/feedbackModal/final-imgs/2.png";
import final3 from "@/../public/modals/feedbackModal/final-imgs/3.png";
import final4 from "@/../public/modals/feedbackModal/final-imgs/4.png";
import final5 from "@/../public/modals/feedbackModal/final-imgs/5.png";

import close from "@/../public/modals/feedbackModal/close.png";

const masks = [
  {
    initialImg: initial1,
    finalImg: final1,
    des: "Poor",
  },
  {
    initialImg: initial2,
    finalImg: final2,
    des: "Bad",
  },
  {
    initialImg: initial3,
    finalImg: final3,
    des: "Average",
  },
  {
    initialImg: initial4,
    finalImg: final4,
    des: "Good",
  },
  {
    initialImg: initial5,
    finalImg: final5,
    des: "Excellent",
  },
];

// console.log(masks[0].initialImg);

export default function FeedbackModal({ setOpenFeedbackModal }) {
  const userDataSelector = useSelector((data) => data.userData);
  const imgGeneratedSelector = useSelector((data) => data.imgGenerated);
  const [selectedMask, setSelectedMask] = useState(null);
  const [feedback, setFeedback] = useState("");
  const [userPhoneNumber, setUserPhoneNumber] = useState(null);
  const [userEmail, setUserEmail] = useState(null);

  useEffect(() => {
    if (userDataSelector.user) {
      setUserPhoneNumber(userDataSelector.user.phoneNumber);
      setUserEmail(userDataSelector.user.email);
    }
  }, [imgGeneratedSelector]);

  // toast options
  const toastOptions = {
    position: "top-center",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
  };

  // console.log(userDataSelector);

  const handleSubmit = async () => {
    // if the user has selected a rating and the user data exists
    if (selectedMask !== null && userDataSelector) {
      const rating = masks[selectedMask].des;
      try {
        // post the rating data to the server
        const response = await axios.patch(
          `${process.env.SERVER_BASE_URL}/user/rating`,
          {
            id: userDataSelector.user._id,
            rating: {
              rating,
              feedback,
            },
          }
        );
        // if the response is successful, show a success toast and close the modal
        if (response.status === 200) {
          toast.success("Thank you for your feedback", toastOptions);
          setOpenFeedbackModal(false);
        } else {
          // if the response is not successful, show an error toast
          toast.error("Failed to submit feedback", toastOptions);
        }
      } catch (error) {
        // if there is an error, show an error toast
        // toast.error("Error submitting feedback", toastOptions);
        console.log(error);
      }
    } else {
      // if the user has not selected a rating, show an error toast
      toast.error("Please select a rating", toastOptions);
    }
  };

  return (
    <div className="flex-row-center FeedbackModal">
      <div className="flex-col-center feedbackBox">
        <h2>How are you Feeling ?</h2>
        <p className={`txt2`}>Would you like to rate your experience ?</p>

        <div className="flex-row-center masksBox">
          {masks.map((item, index) => (
            <div key={index} className="flex-col-center singleMask">
              <div
                onClick={() => setSelectedMask(index)}
                className="flex-row-center img"
              >
                <Image
                  src={selectedMask === index ? item.finalImg : item.initialImg}
                  alt={`${index}`}
                />
              </div>
              <p
                style={selectedMask === index ? { fontWeight: "600" } : {}}
                className="des"
              >
                {item.des}
              </p>
            </div>
          ))}
        </div>

        <div className="feedbackBox">
          <textarea
            value={feedback}
            onChange={(e) => setFeedback(e.target.value)}
            placeholder="Write additional comments here..."
            className="textArea"
          />
        </div>

        <button onClick={handleSubmit} className="btn2 submitBtn">
          Submit
        </button>

        {/* close */}
        <div
          onClick={() => {
            setOpenFeedbackModal(false);
            localStorage.setItem("feedbackStatus", "0");
          }}
          className="flex-row-center close"
        >
          <Image src={close} alt="close" />
        </div>
      </div>

      {/* <ToastContainer /> */}
    </div>
  );
}
